import { Button, ButtonProps } from '@mui/material';
import { useAddNft } from 'entities/mine-package/lib';

interface AddToWalletButtonProps extends Omit<ButtonProps, 'onClick'> {
  tokenId: string | number;
}

export const AddToWalletButton = ({ tokenId, sx, ...props }: AddToWalletButtonProps) => {
  const { addToWallet } = useAddNft();

  return (
    <Button
      variant="outlined"
      sx={{
        minHeight: `40px !important`,
        height: 40,
        fontSize: '13px',
        maxWidth: 130,
        width: '100%',
        padding: '4px',
        ...sx,
      }}
      onClick={() => addToWallet(tokenId)}
      {...props}
    >
      Add To Wallet
    </Button>
  );
};
